export function isOrContainsNode(parent, child) {
  return parent === child || parent.contains(child);
}


//////////////////
// WEBPACK FOOTER
// /home/runner/work/medischeartikelen-website/medischeartikelen-website/node_modules/@algolia/autocomplete-core/dist/esm/utils/isOrContainsNode.js
// module id = 103
// module chunks = 0